export enum ModalMode {
  None = "none",
  Add = "add",
  Edit = "edit",
  Clone = "clone",
}

export interface ModalDataModel {
  type: string;
  mode: ModalMode;
  site: any;
}

export interface OpportunityQueryParam {
  created_by?: string;
  customer_name?: string;
  last_modified_by?: string;
  id?: number;
  opp_type?: number;
  page: number;
  pageSize: number;
  search?: string;
  sfdc_id?: string;
  totalRecords?: number;
  version?: string;
}

export interface OpportunityApiResponse {
  data: any[];
  page: number;
  page_size: number;
  total_records: number;
}